export const checkDataTypeString = (data: any): boolean => {
  return typeof data === 'string'
}
